var _mask, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMuchmoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 58,
    viewBox: "0 0 55 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_299_2641",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.72314,
    y: 36.3062,
    width: 21.474,
    height: 8.66014,
    rx: 0.905525,
    transform: "rotate(45.0201 6.72314 36.3062)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.72314,
    y: 36.3062,
    width: 21.474,
    height: 8.66014,
    rx: 0.905525,
    transform: "rotate(45.0201 6.72314 36.3062)",
    stroke: "#4C4C4C",
    strokeWidth: 2.58721,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_299_2641)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38916 37.8721L14.2685 32.0611C14.2685 32.0611 15.3965 31.0698 16.6271 31.0698C17.8577 31.0698 30.3684 31.1382 30.3684 31.1382C32.4193 31.2749 33.1371 32.4713 33.1371 33.3942C33.1371 34.8641 32.6586 36.4706 30.6077 36.4706",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0443 36.4369H37.3753C37.3753 36.4369 38.6401 36.266 39.6656 35.2064C40.6568 34.1467 49.3391 25.4986 49.3391 25.4986C49.3391 25.4986 50.9457 23.9604 52.4839 25.4986C54.0221 27.0368 53.2018 28.6092 53.2018 28.6092L38.3325 44.6065C38.3325 44.6065 37.683 45.5294 36.2815 45.5636C34.88 45.5978 25.3432 45.5636 25.3432 45.5636C25.3432 45.5636 24.0101 45.461 23.5315 45.9738C23.0188 46.4865 20.0107 49.4946 20.0107 49.4946",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.749 23.6909H27.4152C28.2356 23.6909 28.8851 23.0414 28.8851 22.2894C28.8851 21.5032 28.2356 20.8879 27.4152 20.8879H26.253C25.4327 20.8879 24.7832 20.2384 24.7832 19.4864C24.7832 18.7002 25.4327 18.085 26.253 18.085H28.4407",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5947 23.6914V24.9562",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5947 16.7861V18.0509",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0374 33.2918C10.9864 31.2751 9.41403 27.891 11.8068 22.3193C16.4214 11.5861 22.7793 9.56934 22.7793 9.56934",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4874 36.1973C34.3674 37.0861 48.3821 33.5653 42.6737 22.3193C37.3412 11.8595 31.7012 9.56934 31.7012 9.56934",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4964 9.53483H22.7457C22.1646 9.53483 21.686 9.05628 21.686 8.47518C21.686 7.89408 22.1646 7.41553 22.7457 7.41553H31.4964C32.0775 7.41553 32.556 7.89408 32.556 8.47518C32.556 9.09046 32.0775 9.53483 31.4964 9.53483Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.224 7.41551C23.224 7.41551 21.0363 6.35586 19.9083 4.68092C18.7803 3.00599 18.1992 1.36524 18.1992 1.36524C18.1992 1.36524 19.6691 1.98052 21.5149 2.15144C23.3607 2.32235 24.9673 1.53615 27.0183 1.53615C29.0692 1.53615 30.4707 1.87798 31.6329 2.15144C32.7951 2.42489 35.6664 1.2627 35.6664 1.2627C35.6664 1.2627 33.718 5.94567 30.9834 7.34714",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.0131,
    cy: 20.9901,
    r: 8.08504,
    stroke: "#4C4C4C",
    strokeWidth: 1.29361
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuchmoney);
export default __webpack_public_path__ + "static/media/icon_muchmoney.8d361d6f95e3d1557d640ed8d4dacf8e.svg";
export { ForwardRef as ReactComponent };